require(
      "!../../node_modules/gatsby-module-loader/patch.js"
    );
    module.exports = function(cb) { return require.ensure([], function(_, error) {
        if (error) {
          console.log('bundle loading error', error)
          cb(true)
        } else {
          cb(null, function() { return require("!!../../node_modules/json-loader/index.js!./blog-13-things-you-can-learn-from-buzzfeeds-success-a-study-of-jonah-perettis-marketing-strategies.json") })
        }
      }, "path---blog-13-things-you-can-learn-from-buzzfeeds-success-a-study-of-jonah-perettis-marketing-strategies");
     }
    


//////////////////
// WEBPACK FOOTER
// ./~/gatsby-module-loader?name=path---blog-13-things-you-can-learn-from-buzzfeeds-success-a-study-of-jonah-perettis-marketing-strategies!./.cache/json/blog-13-things-you-can-learn-from-buzzfeeds-success-a-study-of-jonah-perettis-marketing-strategies.json
// module id = 383
// module chunks = 231608221292675